/**
 * Set up routing for all ResourceLink views
 *
 * For an example with protected routes, refer to /product/ProductRouter.js.jsx
 */

// import primary libraries
import React from 'react';
import { Route, Switch } from 'react-router-dom';

// import global components
import Base from "../../global/components/BaseComponent.js.jsx";
import YTRoute from '../../global/components/routing/YTRoute.js.jsx';

// import resourceLink views
import ResourceLinkList from './views/ResourceLinkList.js.jsx';
import SingleResourceLink from './views/SingleResourceLink.js.jsx';

class ResourceLinkRouter extends Base {
  constructor(props) {
    super(props);
  }

  render() {
    return (
      <Switch>
        <YTRoute exact role="admin" path="/resource-links" component={ResourceLinkList} />
        <YTRoute exact role="admin" path="/resource-links/:resourceLinkId" component={SingleResourceLink}/>
      </Switch>
    )
  }
}

export default ResourceLinkRouter;



// WEBPACK FOOTER //
// modules/resourceLink/ResourceLinkAdminRouter.js.jsx